module.exports = __webpack_public_path__ + "static/media/loaded.e8908383.svg";